import React, { useEffect, useState } from "react";
import styles from "./PreviewV3.module.css";

const FIXED_SECTIONS = [
  "document_project_details",
  "document_authorization"
];

const SECTION_COMPONENTS = {
  document_project_details: true,
  document_authorization: true,
  high_risk_activities: true,
  risk_matrix: true,
  job_steps_hazards_consequences_controls: true,
  emergency_contacts: true
};

const SECTION_TYPE_COMPONENTS = {
  method_item_type: true,
  swms_content_management: true,
};

function getSectionComponent(sequenceItem, sectionEntry) {
  const sectionKey = sequenceItem && sequenceItem.item_key;
  const sectionType = sectionEntry && sectionEntry.type;

  return (
    SECTION_COMPONENTS[sectionKey] ||
    SECTION_TYPE_COMPONENTS[sectionType] ||
    null
  );
}

function getVisibleSections(swmsData) {
  const sections = (swmsData && swmsData.sections) || {};
  const meta = (swmsData && swmsData.meta) || {};
  const sequenceMeta = meta.sequence || {};

  const fixedSequence = (sequenceMeta.fixed || []).sort((a, b) =>
    (a.sequence_order || 0) - (b.sequence_order || 0)
  );
  const activeSequence = (sequenceMeta.active || []).sort((a, b) =>
    (a.sequence_order || 0) - (b.sequence_order || 0)
  );

  const allSequenceItems = [...fixedSequence, ...activeSequence];

  return allSequenceItems.filter((sequenceItem) => {
    const { item_key: sectionKey, active: isSequenceActive } = sequenceItem;
    const sectionEntry = sections[sectionKey];
    const sectionData = sectionEntry && sectionEntry.data;
    const Component = getSectionComponent(sequenceItem, sectionEntry);

    if (sectionData == null) return false;

    if (FIXED_SECTIONS.includes(sectionKey)) {
      return Component !== null;
    }

    if (isSequenceActive === 0) return false;
    if (sectionData && sectionData.toggle === 0) return false;
    return Component !== null;
  });
}

export default function PreviewNav({ swmsData }) {
  const visibleSections = getVisibleSections(swmsData);
  const firstVisibleSectionKey = visibleSections[0] ? visibleSections[0].item_key : null;
  const [activeSectionKey, setActiveSectionKey] = useState(firstVisibleSectionKey);

  useEffect(() => {
    setActiveSectionKey(firstVisibleSectionKey);
  }, [firstVisibleSectionKey]);

  return (
    <aside className={styles.PreviewNav}>
      <div className={styles.PreviewNavCard}>
        <div className={styles.PreviewNavHead}><h3>Document Sections</h3></div>
        <div className={styles.PreviewNavList} id="prv-nav-list">
          {visibleSections.map((sequenceItem, index) => {
            const sectionKey = sequenceItem && sequenceItem.item_key;
            const targetId = `sec-${sectionKey}`;
            const isActive = activeSectionKey === sectionKey;

            const handleClick = (event) => {
              event.preventDefault();
              setActiveSectionKey(sectionKey);

              const targetElement = document.getElementById(targetId);
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            };

            return (
              <a
                key={sectionKey}
                className={`${styles.PreviewNavItem} ${isActive ? styles.PreviewNavActiveItem : ""}`}
                data-target={targetId}
                onClick={handleClick}
              >
                <span className={styles.PreviewNavNum}>{index + 1}</span> {sequenceItem && sequenceItem.display_name}
              </a>
            );
          })}
        </div>
      </div>
    </aside>
  )
}